'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var perspectiveAndRotate = (0, _utils.compose)(_utils.perspective, _utils.rotate3d);


var flipInY = {
  from: {
    animationTimingFunction: 'ease-out',
    transform: perspectiveAndRotate('400px', [0, 1, 0, 90]),
    opacity: 0
  },
  '40%': {
    animationTimingFunction: 'ease-in',
    transform: perspectiveAndRotate('400px', [0, 1, 0, -20])
  },
  '60%': {
    transform: perspectiveAndRotate('400px', [0, 1, 0, 10])
  },
  '80%': {
    transform: perspectiveAndRotate('400px', [0, 1, 0, -5])
  },
  to: {
    transform: (0, _utils.perspective)('400px')
  }
};

exports.default = flipInY;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/flip-in-y.js
// module id = 768
// module chunks = 0